export default __webpack_public_path__ + "static/media/f_animation.7e97188d.svg";